const REPORT_FILTERS = [
  { key: 'all', label: 'All reports' },
  { key: 'operational', label: 'Operational' },
  { key: 'financial', label: 'Financial' },
  { key: 'compliance', label: 'Compliance' }
];

const REPORT_DATE_RANGE_OPTIONS = [
  { value: 'last-90-days', label: 'Last 90 days' },
  { value: 'last-30-days', label: 'Last 30 days' },
  { value: 'quarter-to-date', label: 'Quarter to date' }
];

const REPORT_SCOPE_OPTIONS = [
  { value: 'my-caseload', label: 'My caseload (142)' },
  { value: 'high-risk-only', label: 'High-risk only' },
  { value: 'my-domain-mix', label: 'My domain mix' }
];

const REPORT_FORMAT_OPTIONS = [
  { value: 'pdf', label: 'PDF', description: 'Boardroom layout' },
  { value: 'xlsx', label: 'XLSX', description: 'Pivots and charts' },
  { value: 'csv', label: 'CSV', description: 'Raw rows' }
];

const clone = (value) => JSON.parse(JSON.stringify(value));

const OWNER_REPORTS_STATE = {
  active_filter: 'all',
  filters: REPORT_FILTERS,
  report_date_ranges: REPORT_DATE_RANGE_OPTIONS,
  report_scopes: REPORT_SCOPE_OPTIONS,
  report_formats: REPORT_FORMAT_OPTIONS,
  page_title: 'Reports',
  page_description:
    'Run pre-built reports across your caseload. Each report exports to CSV, XLSX or PDF - boardroom-ready, with audit trail.',
  info_callout:
    'X-VERDICT ships as a generic case engine. Categories, role labels and workflows are per-tenant configuration on the same shell.',
  report_modal_open: false,
  selected_report_id: '',
  selected_date_range: 'last-90-days',
  selected_scope: 'my-caseload',
  selected_format: 'pdf',
  reports: [
    {
      id: 'sla-performance',
      category_key: 'operational',
      category_label: 'Operational',
      category_badge_class: 'bg-success-subtle text-success-emphasis border border-success-subtle',
      title: 'SLA performance - last 90 days',
      description: 'On-time vs breached, by domain and handler - 142 cases included',
      action_label: 'Run'
    },
    {
      id: 'risk-band-distribution',
      category_key: 'operational',
      category_label: 'Operational',
      category_badge_class: 'bg-success-subtle text-success-emphasis border border-success-subtle',
      title: 'Risk band distribution',
      description: 'Open cases by risk score band - trend vs prior quarter',
      action_label: 'Run'
    },
    {
      id: 'leakage-flagged',
      category_key: 'financial',
      category_label: 'Financial',
      category_badge_class: 'bg-warning-subtle text-warning-emphasis border border-warning-subtle',
      title: 'Leakage flagged - claims',
      description: 'Value of claims intercepted by risk rules - R 4.2M QTD',
      action_label: 'Run'
    },
    {
      id: 'billable-hours',
      category_key: 'financial',
      category_label: 'Financial',
      category_badge_class: 'bg-warning-subtle text-warning-emphasis border border-warning-subtle',
      title: 'Billable hours by case',
      description: 'Hours logged - billable vs non-billable - for invoicing',
      action_label: 'Run'
    },
    {
      id: 'rule-fire-log',
      category_key: 'compliance',
      category_label: 'Compliance',
      category_badge_class: 'bg-danger-subtle text-danger-emphasis border border-danger-subtle',
      title: 'Rule fire log',
      description: 'Every rule firing this quarter with delta and outcome - audit-ready',
      action_label: 'Run'
    },
    {
      id: 'decision-overrides',
      category_key: 'compliance',
      category_label: 'Compliance',
      category_badge_class: 'bg-danger-subtle text-danger-emphasis border border-danger-subtle',
      title: 'Decision overrides',
      description: 'Cases where the handler decided against the recommended outcome band',
      action_label: 'Run'
    }
  ]
};

function create_owner_reports_state() {
  return clone(OWNER_REPORTS_STATE);
}

export default {
  name: 'OwnerReports',
  data: () => create_owner_reports_state(),
  computed: {
    filtered_reports() {
      if (this.active_filter === 'all') {
        return this.reports;
      }

      return this.reports.filter((report) => report.category_key === this.active_filter);
    },
    selected_report() {
      return this.reports.find((report) => report.id === this.selected_report_id) || null;
    }
  },
  methods: {
    set_filter(filter_key) {
      this.active_filter = filter_key;
    },
    open_report_modal(report) {
      this.selected_report_id = report.id;
      this.selected_date_range = 'last-90-days';
      this.selected_scope = 'my-caseload';
      this.selected_format = 'pdf';
      this.report_modal_open = true;
    },
    close_report_modal() {
      this.report_modal_open = false;
    },
    generate_report() {
      this.close_report_modal();
    }
  }
};
